/** Shopify direct-to-checkout link for The Second-Half Performance Bundle. */
export const CHECKOUT_URL =
  'https://life-shift-362.myshopify.com/cart/52246321594658:1'
